import React, { useContext, useEffect, useMemo, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import Button from 'src/components//button/Button'
import Header from 'src/components//header/Header'
import { StateContext, DispatchContext } from '../../AppContext'
import styles from './fixed-trips.module.scss'
import { usePagination, useSortBy, useTable } from 'react-table'
import { baseApiURL } from 'src/utils/utils'
import emptyListIcon from '../../assets/images/group-11.svg'
import axios from 'axios'
import { IState, ParamTypes } from 'src/Interface'
import { toast } from 'react-toastify'
import Footer from 'src/components/footer/Footer'
import Table from 'src/components/table/Table'
import SubHeader from 'src/components/subHeader/SubHeader'
import useCancellablePromise from 'src/utils/useCancellablePromise'

const FixedTrips: React.FunctionComponent = () => {
  const state: IState = useContext(StateContext)
  const dispatch: React.Dispatch<any> = useContext(DispatchContext)
  const [loading, setLoading] = useState(true)
  const location: any = useLocation()
  const { branchId, companyId } = useParams<ParamTypes>()
  const { cancellablePromise } = useCancellablePromise()
  const [changedData, setChangedData] = useState([])
  const [data, setData] = useState([])
 
  useEffect(() => {
    setData(state.fixedTrips)
    setChangedData(state.fixedTrips)
  }, [state.fixedTrips])

  const  changeRowPosition=(e:any,selectedRow:any,state:string)=>{
    e.stopPropagation(); 
    const index= changedData.findIndex((item:any)=>item.id===selectedRow.id)
     
    const swapIndex = state==="Increase"? index + 1:index - 1
    
    if(swapIndex===-1 || swapIndex===data.length)
    return

    const sortedData=changedData
    const sortOrder=sortedData[index].sortOrder
    sortedData[index].sortOrder=sortedData[swapIndex].sortOrder
    sortedData[swapIndex].sortOrder=sortOrder
    setData(sortedData.sort((a:any,b:any)=>a.sortOrder-b.sortOrder))
  }
  function saveSortOrder(e:any){
    e.stopPropagation(); 
    if (state.user.accessToken) {
      axios.put(`${baseApiURL()}/branches/${branchId}/fixed_trips`,
        changedData, {
        headers: {
          Authorization:
            `Bearer ${state.user.accessToken}`
        }
      })
        .then(() => {
          return null
        }).then(() => {
          return axios(`${baseApiURL()}/branches/${branchId}/fixed_trips/admin`, {
            headers: {
              Authorization:
                `Bearer ${state.user.accessToken}`
            }
          })
        }).then((result: any) => {
          
          dispatch({ type: 'SET_FIXED_TRIPS', fixedTrips: result.data })
          close()
        }).catch((err: any) => {
          toast(err.response.data.message)
        })
    }
    
  }
  const columns = useMemo(() => [
    {
      Header: 'Titel',
      accessor: 'title'
    },
    {
      Header: 'Konto',
      accessor: 'account.code'
    },
    {
      Header: 'Pris',
      accessor: 'price'
    },
    {
      Header: 'Afhentning',
      accessor: 'pickupAddress.fullAddress'
    },
    {
      Header: 'Destination',
      accessor: 'destinationAddress.fullAddress'
    },
    {
      Header: 'Status',
      accessor: 'needsUpdate',
      Cell: item => <p>{item.value ? 'Skal opdateres' : 'Aktiv'}</p>

    },
    {
      Header:JSON.stringify(state.fixedTrips)===JSON.stringify(changedData)? 'Sort' : <Button type='primary' label='Gem Sortering' handleClick={saveSortOrder} />,
      accessor: 'sortOrder',
      disableSortBy:true,
      type:'button',
      Cell: ({row}: any) => {
        return <span className='tw-flex'>
          <svg onClick={(e)=>{changeRowPosition(e,row.original,"Decrease")}} className='tw-w-4 tw-h-4' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M5.293 7.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 5.414V17a1 1 0 11-2 0V5.414L6.707 7.707a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>   
          <svg onClick={(e)=>{changeRowPosition(e,row.original,"Increase")}} className='tw-w-4 tw-h-4 tw-ml-2' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M14.707 12.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 14.586V3a1 1 0 012 0v11.586l2.293-2.293a1 1 0 011.414 0z" clipRule="evenodd" />
          </svg> 
        </span >
      }
    }
  ], [changedData])

  useEffect(() => {
    if (state.user.accessToken) {
      cancellablePromise(axios(`${baseApiURL()}/branches/${branchId}/fixed_trips/admin`, {
        headers: {
          Authorization:
            `Bearer ${state.user.accessToken}`
        }
      }).then((result) => {
        dispatch({ type: 'SET_FIXED_TRIPS', fixedTrips: result.data })
        setLoading(false)
      }).catch((err) => {
        setLoading(false)
        toast(err.response.data.message)
      }))
    }
  }, [dispatch, branchId, state.user.accessToken, cancellablePromise])


  const emptyListModule = () => {
    return loading ?
      (
        <div className='loading '>

        </div>
      ) : (
        <div className={styles.emptyListModule}>
          <div className={styles.emptyListContainer}>
            <img className={styles.emptyListIcon} src={emptyListIcon} alt="" />
            <h3 className={styles.emptyListTitle}>Tilføj faste ture</h3>
            <p className={styles.emptyListText}>Tilføj en fast tur fot at gøre den tilgængelig næste gang du bestiller en tur</p>
            <Button type='primary' label='Opret fast tur' handleClick={() => dispatch({ showModal: true, type: 'SHOW_MODAL', modalType: 'addFixedTrip', branchId, companyId })} />
          </div>
        </div >
      )
  }

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    canNextPage,
    canPreviousPage,
    pageOptions,
    previousPage,
    gotoPage,
    state: pageState,
    nextPage,
    prepareRow,
    sortedRows
  } = useTable({
    columns,
    data,
    autoResetPage: false,
  }, useSortBy, usePagination)

  useEffect(()=>{
    const rows=sortedRows.map((item:any)=>item.original)
    setChangedData(rows.map((item:any,index:number)=>{item.sortOrder=index; return item}))
  },[pageState.sortBy])

  return (
    <>
      <Header />
      <SubHeader loading={loading} backPath={location.state.backPath ? location.state.backPath : '/companies'} title={
        <>
          <svg className='arrow-icon' xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          <span className='color-gray tw-font-normal'>{location.state.from}</span> <span className='tw-mx-3 color-gray tw-font-normal'>/</span> <span className='text-black text-bold'>Faste ture</span>
        </>}
      >
        {state.fixedTrips.length > 0 && <Button modifiers='tw-ml-auto' type='primary' label='Opret fast tur' handleClick={() => dispatch({ showModal: true, type: 'SHOW_MODAL', modalType: 'addFixedTrip', branchId, companyId })} />}
      </SubHeader>
      <main className='container'>
        {state.fixedTrips.length > 0 ?
          <Table
            getTableBodyProps={getTableBodyProps}
            getTableProps={getTableProps}
            prepareRow={prepareRow}
            page={page}
            loading={loading}
            handleClick={(fixedTripId) => dispatch({ type: 'SHOW_ASIDE', asideType: 'FixedTripsDetails', show: true, branchId, fixedTripId, companyId, size: 'small' })}
            headerGroups={headerGroups}
            type='fixedTrips'
            state={{ background: location }}
          />
          : emptyListModule()}
      </main>
      <Footer
        pageState={pageState}
        canNextPage={canNextPage}
        nextPage={nextPage}
        paginationLabel='faste ture'
        canPreviousPage={canPreviousPage}
        loading={loading}
        page={page}
        gotoPage={gotoPage}
        previousPage={previousPage}
        pageOptions={pageOptions}
        itemsLength={state.fixedTrips.length}
      />
    </>
  )
}

export default FixedTrips
